import { AdTagMixin } from '../ad-tag-mixin.ts';
import BunnyStreamVideoElement from './bunny-stream-video.ts';

class BunnyStreamVideoAdsElement extends AdTagMixin(BunnyStreamVideoElement) {}

customElements.define('bunny-stream-video-ads', BunnyStreamVideoAdsElement);

export default BunnyStreamVideoAdsElement;
